import { Record, Map, List } from 'immutable'
import { CUSTOMER_API } from 'constants/ResourcesConstants'
import { PostJsonHeaders, getAuthorizationHeader } from 'utils/Helpers'

export const Team = Record({
  id: undefined,
  inboxId: undefined,
  main: false,
  members: List(),
  name: undefined,
  orgId: undefined,
  slackChannel: null,
  status: undefined,
  updatedAt: undefined,
})

export function parseTeam(data) {
  const { members, ...rest } = data

  return Team({
    members: List(members),
    ...rest,
  })
}

export function parseTeamList(data) {
  return data.reduce((result, team) => result.set(team.id, parseTeam(team)), Map())
}

const TeamsAPI = {
  fetchTeamsForOrg(orgId) {
    return fetch(`${CUSTOMER_API}/organizations/${orgId}/teams`, {
      method: 'GET',
      headers: getAuthorizationHeader(),
    }).then((res) => {
      if (res.ok) {
        return res.json().then(parseTeamList)
      } else {
        throw new Error(`Could not fetch teams for org ${orgId}`)
      }
    })
  },

  updateTeam(teamId, properties) {
    return fetch(`${CUSTOMER_API}/teams/${teamId}`, {
      method: 'PATCH',
      body: JSON.stringify(properties),
      headers: new Headers({
        ...PostJsonHeaders,
        ...getAuthorizationHeader(),
      })
    }).then((res) => {
      if (res.ok) {
        return res.json().then(parseTeam)
      } else {
        throw new Error(`Could not update team ${teamId}`)
      }
    })
  },
}

export default TeamsAPI



// WEBPACK FOOTER //
// ./src/scripts/app/api/TeamsAPI.js